__webpack_require__.p = "/minesider/";